<template>
  <div id="content">
    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="page-header">
            <h1>Gift Cards</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="row has-sidebar">
            <div class="col-md-5 col-lg-4 col-xl-4 col-sidebar">
              <div id="sidebar" class="sidebar-left">
                <div class="sidebar_inner">
                  <div class="card shadow agent-search">
                    <h3 class="subheadline mt0">Filters</h3>
                    <div class="form-group">
                      <label for="location">Enter Title</label>
                      <input type="text" class="form-control" v-model="filterByTitle"
                        placeholder="Show title...">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-8">
              <div class="item-listing list">
                <div class="item" v-for="(giftCard) in paginatedGiftCards" :key="giftCard.id">
                  <GiftCardRow
                    :giftCard="giftCard"
                  />
                </div>

                <b-alert show v-show="totalGiftCards == 0 && !loadingGiftCards" style="background-color: #fff;">
                  <h6> There are no gift cards available.... </h6>
                </b-alert>

                <b-alert show v-show="loadingGiftCards">
                  <h6> Loading Gift Cards </h6>
                </b-alert>
              </div>

              <div class="text-center" v-show="totalGiftCards > 0">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalGiftCards"
                  :per-page="perPage"
                  @imput="giftCards"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <script v-html="giftCardStructuredData" type="application/ld+json" />
  </div>
</template>

<script>
import GiftCardRow from '../common/GiftCardRow.vue'
import GiftCardPublicService from '../../services/GiftCardPublicService'
import StructuredData from '../common/StructuredData'

export default {
  name: 'GiftCardsList',
  mixins: [StructuredData],
  components: {
    GiftCardRow
  },
  data: function () {
    return {
      currentPage: 1,
      perPage: 10,
      filterByTitle: '',
      giftCards: [],
      loadingGiftCards: true,
      giftCardStructuredData: {}
    }
  },
  created () {
    this.loadGiftCardStructuredData()
    this.getGiftCards()
  },
  computed: {
    filteredGiftCards () {
      var self = this

      if (this.filterByTitle || this.filterByEventType || this.currentPage) {
        var title = new RegExp(this.filterByTitle, 'i')

        return this.giftCards.filter((giftCard) => {
          var filterResult = true

          if (self.filterByTitle.length > 0) {
            filterResult = giftCard.title.match(title)
          }

          return filterResult
        })
      } else {
        return this.giftCards
      }
    },
    paginatedGiftCards: function () {
      let indexFrom = (this.currentPage - 1) * this.perPage
      let indexTo = this.perPage * (this.currentPage - 1) + this.perPage
      return this.filteredGiftCards.slice(indexFrom, indexTo)
    },
    totalGiftCards () {
      return this.filteredGiftCards.length
    }
  },
  methods: {
    getGiftCards: function () {
      var self = this
      var loader = this.$loading.show()

      GiftCardPublicService.getGiftCards().then(function (response) {
        self.giftCards = response.data
      }).finally(function () {
        self.loadingGiftCards = false
        loader.hide()
      })
    }
  }
}
</script>
